export const isNullish = (val) => {
  return val === undefined || val === null
}

export const isNumber = (val) => {
  return typeof val === 'number' && !isNaN(val)
}

export const debounce = (func, delay) => {
  let timeoutId
  return (...args) => {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => {
      func(...args)
    }, delay)
  }
}

export const convertToNumber = (val) => {
  if (isNullish(val)) return 0
  const num = parseFloat(val)

  if (isNaN(num)) return 0

  return num
}

export const isTruthyYes = (value) => {
  if (typeof value === 'boolean') return value
  if (typeof value === 'string') return value.trim().toLowerCase() === 'yes'
  return false
}
